import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { LoginForm } from "../components/LoginForm";

export function LoginPage() {
	const { isAuthenticated } = useAuthStore();

	if (isAuthenticated) {
		return <Navigate to="/" replace />;
	}

	return <LoginForm />;
}
